export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            per_page: 10,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        rowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "kod",
                label: "Kód",
                filter: {
                    type: "simple",
                },
                slot_name: "bno_szinezes",
                sort: true,
                visibility: true
            },
            {
                name: "leiras",
                label: "Leírás",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
